import React from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import { CheckIcon, HourglassIcon, CircleIcon } from '../../../model/icons';

const ICONS = { done: <CheckIcon />, current: <HourglassIcon />, lock: <CircleIcon /> };
const IC_CLASS = { done: 'done', current: 'cur', lock: 'lock' };

// Карточка шага последовательности участника (.lg-seq): статус, QR, название точки.
export default function SeqCard({ point, index, qrBaseUrl, status, onMove }) {
    const qrValue = qrBaseUrl ? `${qrBaseUrl}${point.code}` : point.code;
    const clickable = status !== 'current' && !!onMove;
    return (
        <div
            className={`lg-seq ${status}${clickable ? ' clickable' : ''}`}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            onClick={clickable ? onMove : undefined}
            onKeyDown={clickable ? (e) => { if (e.key === 'Enter') onMove(); } : undefined}
        >
            <span className="lg-seqnum">{index + 1}</span>
            <span className={`lg-seqic ${IC_CLASS[status]}`}>{ICONS[status]}</span>
            <div className="lg-sqr">{point.code && <QRCodeSVG value={qrValue} size={46} level="L" />}</div>
            <div className="lg-seqname">{point.name || 'Без названия'}</div>
        </div>
    );
}

SeqCard.propTypes = {
    point: PropTypes.shape({ name: PropTypes.string, code: PropTypes.string }).isRequired,
    index: PropTypes.number.isRequired,
    qrBaseUrl: PropTypes.string,
    status: PropTypes.oneOf(['done', 'current', 'lock']).isRequired,
    onMove: PropTypes.func
};

SeqCard.defaultProps = { qrBaseUrl: null, onMove: undefined };
